import { isFluxErrorCode } from "@buildwithflux/constants";
import { FluxBaseError } from "./FluxBaseError";
/**
 * @deprecated Use `@buildwithflux/shared` directly instead
 */
export { concatErrorArgs, toError } from "@buildwithflux/shared";
/**
 * Check if an error is a given flux error.
 *
 * @param error Anything at all - generally this will be used in a catch clause where the type is unknown.
 * @param errorCodeToMatch The error code to check against.
 * @returns A type predicate indicating that the error is indeed a flux error with the given code.
 * @privateRemarks We could do better with the type narrowing here - the error code doesn't actually give the compiler much
 * information about the specific type of the error, so the developer will still need a cast to make this really useful.
 */
export function isFluxError(error, errorCodeToMatch) {
    return (!!error &&
        error instanceof FluxBaseError &&
        isFluxErrorCode(error.errorCode) &&
        (errorCodeToMatch === undefined || error.errorCode === errorCodeToMatch));
}
//# sourceMappingURL=helpers.js.map